import { matches } from '@/libraries/util/regex'
export { regex } from '@/libraries/util/regex'

/**
 * Encapsulates a regular expression and provides a way to return
 * the original string along with matched and unmatched segments
 * based on the results of the supplied regular expression.
 *
 * @export
 * @class FormTemplateRuleTokenizer
 */
export class FormTemplateRuleTokenizer {
  /**
   * Creates an instance of FormTemplateRuleTokenizer.
   * @param {any} name The name of the tokenizer.
   * @param {any} regex A regex to parse the contents of the submission.
   * @memberof FormTemplateRuleTokenizer
   */
  constructor (name, regex) {
    this.version = 1
    this.name = name
    this.regex = regex
  }

  /**
   * Runs the regular expression on the string.
   *
   * @param {any} string The string to parse.
   * @returns Returns the parts of the string ("tokens")
   * along with metadata about the location of the
   * substring and if each substring matches.
   * @memberof FormTemplateRuleTokenizer
   */
  tokensFromString (string) {
    if (!this.regex) {
      console.log(`FormTemplateRuleTokenizer: missing a regex, can't tokenize. Returning undefined.`)
      return undefined
    }
    return matches(string)
  }

  /**
   * Generates an identifier based on the user visible name.
   *
   * @param {any} name The name of the form.
   * @returns An identifier.
   * @memberof Form
   */
  identifierFromName (name) {
    return 'io.owal.template.rule.tokenizer.' + name.toLowerCase().replace(/\W/g, '')
  }
}
